import React from 'react'
import { useTranslation } from 'react-i18next'
import { CopyButton } from '@node-space/storybook-components'
import { Box } from '@node-space/ui-components'
import { TextSensitive } from 'components/TextSensitive/TextSensitive'

export const ApiKeyText = ({ apiKey }: { apiKey: string }) => {
  const { t } = useTranslation()

  return (
    <Box className="relative">
      <Box className="invisible pr-[65px] md:max-w-[300px] lg:max-w-full break-all">{apiKey}</Box>
      <Box className="absolute top-0 left-0 flex">
        <TextSensitive text={apiKey} textClassName="break-all" />
        <CopyButton copyText={apiKey} confirmationMessage={t('copiedToClipboard')} />
      </Box>
    </Box>
  )
}
